import React, { useMemo, useState, useCallback } from "react";
import SearchComponent from "../../components/Search";
import PaginationComponent from "../../components/Pagination/Pagination";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import moment from 'moment'
import { getGroupLoansByCooperative } from "../../redux/Loans/loanActions";
import { useDispatch } from "react-redux";

const GroupLoanApplicationTable = () => {

  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch()
  const { GroupLoans, loading, GroupLoanCount } = useSelector((state) => state.loan);
  const { group } = useParams()
  const [currentPage, setCurrentPage] = useState(1);

  const onPageChange = (val) => {
    const { page } = val;
    setCurrentPage(page);
  };

  const [typeID, setTypeID] = useState(1);
  const loanTypes = [
    {
      id: 1,
      title: "All",
    },
    {
      id: 2,
      title: "Pending",
    },
    {
      id: 3,
      title: "Approved",
    },
    {
      id: 4,
      title: "Rejected",
    },
  ];

  const toggleType = (id) => {
    setTypeID(id);


    switch (id) {
      case 1:
        dispatch(
          getGroupLoansByCooperative({
            type: 'all',
            code: group
          }),
        )
        break
      case 2:
        dispatch(
          getGroupLoansByCooperative({
            type: 'pending',
            code: group
          }),
        )
        break
      case 3:
        dispatch(
          getGroupLoansByCooperative({
            type: 'active',
            code: group
          }),
        )
        break
      case 4:
        dispatch(
          getGroupLoansByCooperative({
            type: 'rejected',
            code: group
          }),
        )
        break
      default:
        break
    }
  };

  const getLoanBg = (val) => {
    let result
    switch (val) {
      case 'pending':
        result = 'pending-badge'
        break;
      case 'inactive':
        result = 'error-badge'
        break
      case 'active':
        result = 'success-badge'
        break;
        case "completed":
          result = "success-badge"
          break;
          case "approved":
            result = "success-badge"
            break;
            case "rejected":
              result = "error-badge"
              break;
      default:
        result = 'error-badge'
        break
    }
    return result
  }

  const getLoanText = (val) => {
    let result
    switch (val) {
      case 'pending':
        result = 'Pending'
        break;
      case 'inactive':
        result = 'Inactive'
        break
      case 'active':
        result = 'Active'
        break;
      case "completed":
        result = "Completed"
        break;
        case "approved":
          result = "Approved"
          break;
          case "rejected":
            result = "Rejected"
            break;
      default:
        result = 'Pending'
        break
    }
    return result
  }

  // handle search
  const handleSearch = useMemo(
    () =>
      debounce((val) => {
        //  api to dispatch and make the actions for search
        // dispatch(
        //     searchCallRequests({
        //       val: val,
        //       status: 'all',
        //     }),
        //   )
        console.log(val);
      }, 750),
    []
  );

  const handleChange = useCallback(
    (e) => {
      let val = e.target.value;
      setSearchValue(val);
      handleSearch(val);
    },
    [handleSearch]
  );

  return (
    <>
      <div className="mt-4 bg-white rounded-[8px]">
        <div className="p-4">
          <p className="text-primary font-semibold text-base leading-5">
            Loan Application
          </p>

          {/* search */}
          <div className="mt-4">
            <SearchComponent
              placeholder="Search..."
              searchValue={searchValue}
              handleChange={handleChange}
            />
          </div>

          <ul className="flex mt-5 gap-5 items-center">
            {loanTypes.map((item) => (
              <li
                key={item.id}
                onClick={() => toggleType(item.id)}
                className={
                  typeID === item.id
                    ? "flex gap-1 items-center border-b-2 border-primary pb-1 cursor-pointer"
                    : "flex gap-2 items-center pb-1 cursor-pointer"
                }
              >
                <p
                  className={
                    typeID === item.id
                      ? "text-primary text-sm font-semibold"
                      : "text-[#96A397] text-sm font-semibold"
                  }
                >
                  {item.title}
                </p>
                <span
                  className={
                    typeID === item.id
                      ? 'bg-[#DBFFDF] rounded-[4px] py-1 px-1 text-primary font-semibold text-[10px]'
                      : ''
                  }
                >
                  {typeID === item.id ? GroupLoanCount : ''}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* tables */}
        <div className="overflow-x-auto relative">
          <table className="w-full text-left">
            <thead className="text-primary text-sm border-b-[#F7F7F7] border-b-2">
              <tr>
                <th scope="col" className="px-4 py-4 font-semibold ">
                  Date Created
                </th>

                <th scope="col" className="px-4 py-4 font-semibold">
                  Name
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Phone Number
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Cooperative Name
                </th>
                <th scope="col" className="px-4 py-4 font-semibold">
                  Loan Amount
                </th>

                <th scope="col" className="px-4 py-4 font-semibold">
                  Loan Status
                </th>
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {GroupLoans.length > 0
                  ? GroupLoans.map((item) => (
                    <tr
                      onClick={() => navigate(`/agrofastcash/loan-review/${item.id}`)}
                      className="bg-white text-sm cursor-pointer hover:bg-[#EDF7EE]"
                    >
                      <th
                        scope="row"
                        className="py-4 px-4 font-normal text-[#5C715E] whitespace-nowrap "
                      >
                        {moment(item._created).format('Do, MMM YYYY')}

                      </th>

                      <td className="py-4 px-4 text-[#5C715E]">{item.farmer.farmer_name}</td>
                      <td className="py-4 px-4 text-[#5C715E]">{item.farmer.farmer_phone_number}</td>
                      <td className="py-4 px-4 text-[#5C715E]">{item.cooperative.cooperative_name}</td>
                      <td className="py-4 px-4">₦{item.loan_principal}</td>

                      <td className="py-4 px-4">
                        <div className="flex">
                          <div className={getLoanBg(item.loan_status)}>
                            <p>{getLoanText(item.loan_status)}</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))
                  : ""}
              </tbody>
            )}
          </table>

          {loading && (
            <div className="animate-pulse w-full mt-4 px-4 mb-4">
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full mb-2"></div>
              <div className="h-10 bg-gray-200 rounded-lg  w-full"></div>
            </div>
          )}
        </div>
      </div>
      <div className="mt-1">
        <PaginationComponent
          page={currentPage}
          onPageChange={(page) => onPageChange({ page })}
          pageSize={10}
          totalItems={GroupLoanCount}
        />
      </div>
    </>
  );
};

export default GroupLoanApplicationTable;
